import React, { useState } from "react";
import { FieldValues, SubmitHandler, useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import { IRootState } from "../reducer/store";
import FormInput from "../components/form/formInput/FormInput";
import FormSelect from "../components/form/formSelect/FormSelect";
import FormButton from "../components/form/formButton/FormButton";
import PaymentPop from "../components/modal/PaymentPop";

const PassengerDetails = () => {
  const { register, formState, handleSubmit, control } = useForm();
  const onBookRide: SubmitHandler<FieldValues> = (formData) => {
    setIsActive(true);
  };
  const bookings = useSelector(
    (state: IRootState) => state.booking.value.booking
  );
  const seats = useSelector((state: IRootState) => state.booking.value.seat);

  const [isActive, setIsActive] = useState(false);
  return (
    <>
      {isActive && <PaymentPop onClose={() => setIsActive(false)} />}
      <div className="bg-[#F9F9F9]">
        <div className="bg-[#620005]">
          <div className="container mx-auto pt-28 md:pt-36 pb-12 px-5 text-white">
            <div className="flex flex-col items-center gap-3">
              <div className="head text-2xl">Passenger Details</div>
              <div className="">
                Thank you, merely a few further data about you
              </div>
            </div>
          </div>
        </div>
        <div className="">
          <div className="container mx-auto  px-4 py-10">
            <form
              onSubmit={handleSubmit(onBookRide)}
              className="grid grid-cols-1 md:grid-cols-2 gap-3"
            >
              <div className="flex flex-col gap-3">
                <div className="bg-white flex flex-col p-4 md:px-6">
                  <div className="flex">
                    <div className="text-lg font-semibold mb-4">
                      Passenger's Details
                    </div>
                  </div>
                  <div className="">
                    <FormInput
                      color="blue"
                      formState={formState}
                      name="name"
                      register={register}
                      rules={{ required: "Enter name" }}
                      type="text"
                      label="Full Name"
                      placeholder="Enter full name"
                    />
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
                      <FormInput
                        color="blue"
                        formState={formState}
                        name="phonenumber"
                        register={register}
                        rules={{ required: "Enter phonenumber" }}
                        type="text"
                        label="Phone Number"
                        placeholder="Enter phone number"
                      />
                      <FormInput
                        color="blue"
                        formState={formState}
                        name="email"
                        register={register}
                        rules={{ required: "Enter email" }}
                        type="email"
                        label="Email Address"
                        placeholder="Enter email"
                      />
                    </div>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
                      <FormSelect
                        color="blue"
                        control={control}
                        formState={formState}
                        label="Gender"
                        name="gender"
                        options={[
                          { label: "Male", value: "Male" },
                          { label: "Female", value: "Female" },
                        ]}
                        rules={{ required: "select one" }}
                        placeholder="Select gneder"
                      />
                      <FormInput
                        formState={formState}
                        name="date"
                        placeholder="Enter date"
                        label="Date of Birth"
                        register={register}
                        rules={{ required: "Select date" }}
                        type="date"
                        color="white"
                      />
                    </div>

                    <hr className="mt-6 mb-5" />
                    <div className="head text-xl font-semibold">
                      Next of Kin's Details
                    </div>
                    <FormInput
                      color="blue"
                      formState={formState}
                      name="nextofkinname"
                      register={register}
                      rules={{ required: "Enter name" }}
                      type="text"
                      label="Full Name"
                      placeholder="Enter full name"
                    />
                    <FormInput
                      color="blue"
                      formState={formState}
                      name="nextofkinphonenumber"
                      register={register}
                      rules={{ required: "Enter phonenumber" }}
                      type="text"
                      label="Phone Number"
                      placeholder="Enter phone number"
                    />
                  </div>
                </div>
                {/* <div className="bg-white flex flex-col p-4 md:px-6">
                  <div className="flex">
                    <div className="text-lg font-semibold mb-4">
                      Passenger's Details
                    </div>
                  </div>
                  <div className="">
                    <FormInput
                      color="blue"
                      formState={formState}
                      name="name"
                      register={register}
                      rules={{ required: "Enter name" }}
                      type="text"
                      label="Full Name"
                      placeholder="Enter full name"
                    />
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
                      <FormInput
                        color="blue"
                        formState={formState}
                        name="phonenumber"
                        register={register}
                        rules={{ required: "Enter phonenumber" }}
                        type="text"
                        label="Phone Number"
                        placeholder="Enter phone number"
                      />
                      <FormInput
                        color="blue"
                        formState={formState}
                        name="email"
                        register={register}
                        rules={{ required: "Enter email" }}
                        type="email"
                        label="Email Address"
                        placeholder="Enter email"
                      />
                    </div>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
                      <FormSelect
                        color="blue"
                        control={control}
                        formState={formState}
                        label="Gender"
                        name="gender"
                        options={[
                          { label: "Male", value: "Male" },
                          { label: "Female", value: "Female" },
                        ]}
                        rules={{ required: "select one" }}
                        placeholder="Select gneder"
                      />
                      <FormInput
                        formState={formState}
                        name="date"
                        placeholder="Enter date"
                        label="Date of Birth"
                        register={register}
                        rules={{ required: "Select date" }}
                        type="date"
                        color="white"
                      />
                    </div>

                    <hr className="mt-6 mb-5" />
                    <div className="head text-xl font-semibold">
                      Next of Kin's Details
                    </div>
                    <FormInput
                      color="blue"
                      formState={formState}
                      name="nextofkinname"
                      register={register}
                      rules={{ required: "Enter name" }}
                      type="text"
                      label="Full Name"
                      placeholder="Enter full name"
                    />
                    <FormInput
                      color="blue"
                      formState={formState}
                      name="nextofkinphonenumber"
                      register={register}
                      rules={{ required: "Enter phonenumber" }}
                      type="text"
                      label="Phone Number"
                      placeholder="Enter phone number"
                    />
                  </div>
                </div> */}
              </div>
              {/*  */}
              <div className="bg-white md:sticky md:top-[92px] flex flex-col p-4 md:px-6 h-fit">
                <div className="text-pry text-lg text-center font-semibold mb-4">
                  Trip Summary
                </div>
                <div className="flex flex-col gap-6">
                  <div className="flex items-center justify-between">
                    <div className="text-[#757575] text-sm font-[500]">
                      Departure
                    </div>
                    <div className=" text-sm font font-semibold">
                      {bookings.to}
                    </div>
                  </div>
                  <div className="flex items-center justify-between">
                    <div className="text-[#757575] text-sm font-[500]">
                      Destination
                    </div>
                    <div className=" text-sm font font-semibold">
                      {bookings.from}
                    </div>
                  </div>
                  <div className="flex items-center justify-between">
                    <div className="text-[#757575] text-sm font-[500]">
                      Date
                    </div>
                    <div className=" text-sm font font-semibold">
                      {bookings.returnDate}
                    </div>
                  </div>
                  <div className="flex items-center justify-between">
                    <div className="text-[#757575] text-sm font-[500]">
                      Time
                    </div>
                    <div className=" text-sm font font-semibold">06:00am</div>
                  </div>
                  <div className="flex items-center justify-between">
                    <div className="text-[#757575] text-sm font-[500]">
                      Adult(s)
                    </div>
                    <div className=" text-sm font font-semibold">
                      {bookings.adult}
                    </div>
                  </div>
                  <div className="flex items-center justify-between">
                    <div className="text-[#757575] text-sm font-[500]">
                      Seat Number(s)
                    </div>
                    <div className="flex items-center gap-1 text-sm font font-semibold">
                      <div className="">Seat</div>{" "}
                      <div className="flex">
                        {seats.map((i) => (
                          <p>{i}.</p>
                        ))}
                      </div>
                    </div>
                  </div>
                  <div className="flex items-center justify-between">
                    <div className="text-[#757575] text-sm font-[500]">
                      Price
                    </div>
                    <div className=" text-sm font font-semibold">N 24,740</div>
                  </div>
                  <div className="flex items-center justify-between">
                    <div className="text-[#757575] text-sm font-[500]">
                      Discount
                    </div>
                    <div className=" text-sm font font-semibold">N 0</div>
                  </div>
                  <div className="flex items-center justify-between">
                    <div className="text-[#757575] text-sm font-[500]">
                      Total Amount
                    </div>
                    <div className=" text-lg font font-semibold">N 24,740</div>
                  </div>
                </div>
                <FormButton
                  error={false}
                  label="Proceed To Payment"
                  loading={false}
                />
              </div>
            </form>
          </div>
        </div>
        <div className="">
          <div className="container mx-auto  px-4 py-5 pb-10">
            <div className="md:w-1/2">
              <div className="text-pry text-xl font-bold mb-5">
                Terms & Conditions
              </div>
              <div className="">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
                enim ad minim veniam, quis nostrud exercitation ullamco laboris
                nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor
                in reprehenderit in voluptate velit esse cillum dolore eu fugiat
                nulla pariatur. Excepteur sint occaecat cupidatat non proident,
                sunt in culpa qui officia deserunt mollit anim id est laborum.
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PassengerDetails;
